<script lang="ts">
  import BrandMark from '../shared/BrandMark.svelte';

  const links = {
    product: [
      ['Features', '#innovations'],
      ['Level 0', '#level0'],
      ['Compare', '#compare']
    ],
    vu: [
      ['VuChat', '#'],
      ['VuMail', '#'],
      ['VuPhoto', '#'],
      ['All apps →', '#']
    ],
    resources: [
      ['Source · GitHub', '#'],
      ['Threat model', '#'],
      ['Reproducible build', '#'],
      ['Contact', '#']
    ]
  };
</script>

<footer class="footer">
  <div class="wrap">
    <div class="grid">
      <div>
        <BrandMark href="#top" />
        <p class="tag">
          An <em>honest</em> authenticator. Part of the VU ecosystem — 30+ apps unified by mathematical
          privacy.
        </p>
      </div>
      <div>
        <div class="head">Product</div>
        {#each links.product as [label, href] (href)}
          <a class="link" {href}>{label}</a>
        {/each}
      </div>
      <div>
        <div class="head">VU Labs</div>
        {#each links.vu as [label, href] (label)}
          <a class="link" {href}>{label}</a>
        {/each}
      </div>
      <div>
        <div class="head">Resources</div>
        {#each links.resources as [label, href] (label)}
          <a class="link" {href}>{label}</a>
        {/each}
      </div>
    </div>
    <div class="bottom">
      <span>© 2026 Vu Labs · YOUR data. YOUR device. YOUR control.</span>
      <span class="bottom-r">
        <span class="dot"></span>
        0 packets sent rendering this page
      </span>
    </div>
  </div>
</footer>

<style>
  .footer {
    padding: 56px 0 80px;
    border-top: 1px solid var(--border);
  }
  :global([data-theme='brutalist']) .footer {
    border-top: 2px solid var(--text);
  }
  .wrap {
    max-width: var(--max-w);
    margin: 0 auto;
    padding: 0 var(--gutter);
  }
  .grid {
    display: grid;
    grid-template-columns: 1.4fr 1fr 1fr 1fr;
    gap: 48px;
    margin-bottom: 48px;
  }
  @media (max-width: 768px) {
    .grid {
      grid-template-columns: 1fr 1fr;
      gap: 32px;
    }
  }
  @media (max-width: 480px) {
    .grid {
      grid-template-columns: 1fr;
      gap: 28px;
    }
  }
  .tag {
    font-size: 13px;
    color: var(--text-3);
    max-width: 280px;
    line-height: 1.55;
  }
  .tag em {
    font-family: var(--font-serif);
    font-style: italic;
    color: var(--accent);
  }
  :global([data-theme='brutalist']) .tag em {
    color: var(--text);
  }
  .head {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: var(--text-3);
    margin-bottom: 16px;
  }
  .link {
    display: block;
    padding: 4px 0;
    font-size: 14px;
    color: var(--text-2);
    text-decoration: none;
    transition: color var(--t);
  }
  .link:hover {
    color: var(--text);
  }
  .bottom {
    padding-top: 24px;
    border-top: 1px solid var(--border);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    font-size: 12px;
    color: var(--text-3);
  }
  :global([data-theme='brutalist']) .bottom {
    border-top: 2px solid var(--text);
  }
  .bottom-r {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--good);
    box-shadow: 0 0 6px var(--good);
  }
  :global([data-theme='brutalist']) .dot {
    border-radius: 0;
    box-shadow: none;
  }
</style>
